/**
 * @version 1.0alpha
 * @author Kelnik Studios {http://kelnik.ru}
 * @link https://kelnik.gitbooks.io/kelnik-documentation/content/front-end/components/popup.html documentation
 */

/**
 * DEPENDENCIES
 */
import actionContentTemplate from './contentTemplates/action-content-popup.twig';
import axios from 'axios';
import cookiesContentTemplate from './contentTemplates/cookies-content-popup.twig';
import infrastructureContentTemplate from './contentTemplates/infrastructure-content-popup.twig';
import Observer from 'common/scripts/observer';
import progressContentTemplate from './contentTemplates/progress-content-popup.twig';
import progressVideoContentTemplate from './contentTemplates/progress-video-popup.twig';
import promoContentTemplate from './contentTemplates/promo-content-popup.twig';
import resetContentTemplate from './contentTemplates/reset-content-popup.twig';
import template from './templates/popup.twig';
import templateFull from './templates/popup-full.twig';
import templateMarginless from './templates/popup-marginless.twig';
import templateMedium from './templates/popup-medium.twig';
import templateNarrow from './templates/popup-narrow.twig';
import templateReset from './templates/popup-reset.twig';
import templateZoom from './templates/popup-zoom.twig';
import Utils from 'common/scripts/utils';
import zoomContentTemplate from './contentTemplates/zoom-content-popup.twig';

const templates = {
    classic   : template,
    full      : templateFull,
    marginless: templateMarginless,
    narrow    : templateNarrow,
    medium    : templateMedium,
    reset     : templateReset,
    zoom      : templateZoom
};

const contents = {
    action        : actionContentTemplate,
    cookies       : cookiesContentTemplate,
    infrastructure: infrastructureContentTemplate,
    progress      : progressContentTemplate,
    progressVideo : progressVideoContentTemplate,
    promo         : promoContentTemplate,
    reset         : resetContentTemplate,
    zoom          : zoomContentTemplate
};

const errors = {
    emptyTemplate       : `Отсутствует шаблон для попапа. Создай twig и добавь его в templates`,
    emptyContentTemplate: `Дружище - ты получаешь контент аяксом.
        Создай twig шаблон контента и укажи его в настройках и объекте contents`
};

const observer = new Observer();

class Popup {
    constructor(options) {
        this.options = options;
        this.openButtons = options.openButtons;
        this.openLoadPage = options.openLoadPage !== false;
        this.body = document.body;
        this.closeButtonAriaLabel = options.closeButtonAriaLabel || 'Закрыть всплывающее окно';
        this.stateClass = 'is-open';
        this.animateClass = 'is-animate';
        this.isDark = options.isDark || false;
        // ID кнопок открытия текущего попапа
        this.openButtons.ids = [];
        // Нужно ли удалять попап
        this.needRemovePopup = options.remove || false;
    }

    init() {
        this._bindEvents();
        this._setTemplate();
        this._parseUrl();
        this._subscribes();
    }

    _setTemplate() {
        this.template = templates[this.options.template] || console.error(errors.emptyContentTemplate);
    }

    _setContentTemplate() {
        this.templateContent = contents[this.options.templateContent] || console.error(errors.emptyTemplate);
    }

    /**
     * Вешаем слушателей событий
     */
    _bindEvents() {
        this.openButtons.forEach((item) => {
            this.openButtons.ids.push(item.dataset.popupId);

            item.addEventListener('click', (event) => {
                event.preventDefault();

                this.target = event.currentTarget;
                this.id = this.target.dataset.popupId;
                this.planoplanUid = this.target.dataset.planoplan;
                this._seoSignal(this.id);
                this._makeOpen();
            });
        });

        document.addEventListener('keyup', (element) => {
            this._closeOnPressButton(element);
        });
    }

    /**
     * Метод содержит в себе колбэки событий других модулей.
     */
    _subscribes() {
        observer.subscribe('sendForm', (popupInstance) => {
            // если закрываемый попап, равен текущему экземпляру
            if (popupInstance === this) {
                this._close();
            }
        });
    }

    /**
     * Метод для передачи информации сеошникам при открытии попапа
     * @param {String} id - id кнопки открытия попапа
     */
    _seoSignal(id) {
        /* eslint-disable */
        if (id === '#callback-call') {
            dataLayer = dataLayer || [];
            dataLayer.push ({'event':'gaEvent', 'gaCategory':'form', 'gaAction':'open', 'gaLabel':'callback-header'});
            dataLayer.push ({'event': 'Pageview', 'pagePath': '/#form-open-callback-header','pageTitle': `${document.title} - Заказать звонок в шапке - показ формы`});
        }

        if (id === '#callback-flat') {
            dataLayer = dataLayer || [];
            dataLayer.push ({'event':'gaEvent', 'gaCategory':'form', 'gaAction':'open', 'gaLabel':'flatRequest'});
            dataLayer.push ({'event': 'Pageview', 'pagePath': '/#form-open-flatRequest','pageTitle': `${document.title} - Заявка на квартиру - показ формы`});
        }
        /* eslint-enable */
    }

    /**
     * Байнд событий после создания popup.
     */
    _bindEventsAfterOpen() {
        const that = this;

        // Закрываем попап кликом по оверлею
        that.popup.addEventListener('click', (element) => {
            that._closeOnClickOverlay(element);
        });

        // Закрываем попап кликом по обычной кнопке-крестику
        if (that.closeButton) {
            that.closeButton.addEventListener('click', that._close.bind(this));
        }

        // Cсылка внутри промо-попапа, по которой его тоже нужно закрывать
        // и переходить на акцию в другой попап, перезагрузив страницу
        const closePromoButtons = that.popup.querySelectorAll('.j-promo-popup-close');

        that.popup.addEventListener('click', (element) => {
            that._closeOnClickOverlay(element);
        });

        if (closePromoButtons.length) {
            closePromoButtons.forEach((item) => {
                item.addEventListener('click', (evt) => {
                    evt.preventDefault();
                    that._close();
                    const url = item.href;

                    window.location.href = url;
                    window.location.reload();
                });
            });
        }

        // Закрываем попап кнопками с ресетом избранного
        const closeResetButtons = that.popup.querySelectorAll('.j-reset-popup-close');

        if (closeResetButtons.length) {
            closeResetButtons.forEach((item) => {
                item.addEventListener('click', (evt) => {
                    evt.preventDefault();
                    that._close();

                    // кнопки две, а ресетить должна только одна, вторая - просто закрывает попап
                    if (item.hasAttribute('data-reset')) {
                        observer.publish('reset-favorite');
                    }
                });
            });
        }
    }

    /**
     * Запуск попапа при клике на кнопку.
     */
    _makeOpen() {
        this.openPopup = this.body.querySelector(`[data-popup="${this.id}"]`);

        if (this.openPopup) {
            this.popup = this.openPopup;
            this._show();
        } else {
            this._contentTypeCheck();
        }

        if (this.planoplanUid) {
            this._planoplanInit();
        }

        observer.publish('createPopup', this.popup, this);
        setTimeout(() => {
            observer.publish('lazyLoad:refresh');
        }, 0);
    }

    /**
     * Проверка типа попапа - статика/ajax.
     */
    _contentTypeCheck() {
        const dataAttributeHref = this.target.dataset.href;
        const dataAttributeAjax = this.target.dataset.ajax;
        const dataAttributeJson = this.target.dataset.json;
        const dataAttributeZoom = this.target.dataset.zoom;

        if (dataAttributeZoom) {
            const content = this._collectZoomData();

            this._outputOnDisplay();
            this._setContentTemplate();
            this._insetContent(this.content, this.templateContent(content));

            this.closeButton = this.content.querySelector('.popup__close');

            if (this.closeButton) {
                this.closeButton.addEventListener('click', this._close.bind(this));
            }

            return;
        }

        if (dataAttributeHref) {
            const contentId = document.getElementById(dataAttributeHref);

            if (!contentId) {
                console.error(`Создай контентный блок попапа с id "${dataAttributeHref}"`);

                return;
            }

            const staticContent = contentId.innerHTML;

            this._outputOnDisplay(staticContent);

            return;
        }

        if (dataAttributeAjax) {
            this._outputOnDisplay();
            this._setContentTemplate();
            this._collectData();
            this._send();

            return;
        }

        if (dataAttributeJson) {
            const response = JSON.parse(atob(dataAttributeJson));
            const content = response.data.content;

            this._outputOnDisplay();
            this._setContentTemplate();
            this._insetContent(this.content, this.templateContent(content));
        }
    }

    /**
     * Вывод попапа на экран.
     * @param {String} content - контент из статики или из json.
     */
    _outputOnDisplay(content) {
        this._setData(content);
        this._insertTemplate();
        this._getElements();
        this._show();
    }

    /**
     * Подготовка данных для шаблона
     * @param {String} content - контент из статики или из json.
     */
    _setData(content) {
        this.data = {
            content,
            id             : this.id,
            buttonAriaLabel: this.closeButtonAriaLabel
        };
    }

    /**
     * Вставка шаблона.
     */
    _insertTemplate() {
        this.body.insertAdjacentHTML('afterbegin', this.template(this.data));
    }

    /**
     * Получаем попап и его элементы, вешаем события.
     */
    _getElements() {
        this.popup = document.querySelector('.popup');
        this.content = document.querySelector('.popup__content');
        this.closeButton = this.popup.querySelector('.popup__close');
        this.overlay = this.popup.querySelector('.popup__overlay');
        this.preloader = this.popup.querySelector('.popup__preloader');
        this._bindEventsAfterOpen();
    }

    /**
     * Вставка контента
     * @param {String} popup - элемент, куда вставляется контент. (не сам попап, а его контентная часть!)
     * @param {String} content - вставляемый контент.
     */
    _insetContent(popup, content) {
        Utils.clearHtml(popup);
        Utils.insetContent(popup, content);

        observer.publish('insetContentPopup', popup, this);
    }

    _collectData() {
        this.formData = new FormData();
        this.formData.append('id', this.target.dataset.id);
    }

    /**
     * Метод отправки ajax запроса
     * @param {Object} sentData - отправляемые данные.
     * @return {Boolean} - false - если нет интернета, запрос прерывается.
     * @return {Boolean} - true - успешное выполнение запроса.
     */
    _send() {
        this._showPreloader();

        if (!this._checkInternet()) {
            this._resending();

            return false;
        }

        axios.post(this.target.dataset.ajax, this.formData)
            .then((response) => {
                const data = response.data.data;

                if (data) {
                    this._insetContent(this.content, this.templateContent(data.content));
                } else {
                    this._errorHandler('data');
                    console.error(response.request.errors);
                }

                this._hidePreloader();
                setTimeout(() => {
                    observer.publish('lazyLoad:refresh');
                }, 0);
            })
            .catch((error) => {
                this._hidePreloader();
                this._errorHandler('server');
                console.error(`server error ${error}`);
            });

        return true;
    }

    /**
     * Метод закрытия попапа по клику на оверлей.
     * @param {Object} element - элемент по которому произошло событие. Cм. метод bindEventsAfterOpen
     */
    _closeOnClickOverlay(element) {
        if (element.target === this.overlay) {
            this._close();
        }
    }

    /**
     * Метод закрытия попапа по нажатию на ESC
     * @param {Object} element - элемент по которому произошло событие. Cм. метод bindEvents
     */
    _closeOnPressButton(element) {
        const keyCodeESC = 27;

        if (element.keyCode === keyCodeESC) {
            this._close();
        }
    }

    /**
     * Метод подменяет data-src на src
     * Нужно чтобы плеер не грузился раньше времени
     */
    _loadAfterOpen() {
        const elements = Array.from(this.popup.querySelectorAll('[data-src]'));

        if (elements.length) {
            elements.forEach((element) => {
                const targetAttribute = element.nodeName === 'SOURCE' ? 'srcset' : 'src';
                const sourceElement = element.nodeName === 'SOURCE' ? 'data-srcset' : 'data-src';

                if (element.getAttribute(sourceElement)) {
                    element.setAttribute(targetAttribute, element.getAttribute(sourceElement));
                    element.removeAttribute(sourceElement);
                }
            });
        }
    }

    /**
     * Метод открывает попап
     */
    _show() {
        Utils.bodyFixed(this.popup);

        this._loadAfterOpen();

        this.popup.classList.add(this.stateClass);

        if (this.isDark) {
            this.popup.classList.add('popup_theme_dark');
        }

        if (this.options.templateContent === 'progress' || this.options.templateContent === 'progressVideo') {
            this.popup.classList.add('popup_theme_progress');
        }

        this._setUrl();

        setTimeout(() => {
            this.popup.classList.add(this.animateClass);
        }, 100);
        observer.publish('showPopup', this);
    }

    /**
     * Метод закрывает попап
     */
    _close() {
        if (!this.popup) {
            return;
        }

        this._stopVideo();

        this.popup.classList.remove(this.animateClass);
        this._clearUrl();
        window.sessionStorage.removeItem('callback-init');

        if (this.needRemovePopup) {
            this._remove();
        }

        setTimeout(() => {
            if (this.options.templateContent === 'progress' || this.options.templateContent === 'progressVideo') {
                this.popup.remove();
            } else {
                this.popup.classList.remove(this.stateClass);
            }

            Utils.bodyStatic();
            observer.publish('closePopup');
        }, 300);
    }

    /**
     * Удаление попапа со страницы.
     */
    _remove() {
        Utils.removeElement(this.popup);
        Utils.bodyStatic();
    }

    /**
     * Метод останавливает проигрывание видео в попапе (есть есть видео)
     */
    _stopVideo() {
        const players = this.popup.querySelectorAll('.video-iframe');

        if (!players.length) {
            return;
        }

        players.forEach((player) => {
            const videoSrc = player.getAttribute('src');

            player.setAttribute('src', '');
            player.setAttribute('src', videoSrc);
        });
    }

    /**
     * Метод обработки ошибок.
     * @param {String} typeError - тип ошибки.
     */
    _errorHandler(typeError) {
        const errorList = [{
            type: 'internet',
            html: '<h1>Вы не подключены к интернету. Повторите запрос позднее</h1>'
        }, {
            type: 'server',
            html: '<h1>На сервере произошла ошибка. Повторите запрос позднее</h1>'
        }, {
            type: 'data',
            html: '<h1>На сервере произошла ошибка. Повторите запрос позднее</h1>'
        }];

        errorList.forEach((item) => {
            if (typeError === item.type) {
                this._insetContent(this.content, item.html);
            }
        });
    }

    /**
     * Проверка на наличие интернета.
     * @return {boolean} true - интернет есть.
     * @return {boolean} false - интернетa нет.
     */
    _checkInternet() {
        clearInterval(this.setInterval);
        if (!Utils.checkInternetConnection()) {
            this._errorHandler('internet');

            return false;
        }

        return true;
    }

    /**
     * Повторный запрос на сервер.
     * @param {object} sentData - отрправляемые данные.
     *
     */
    _resending() {
        const interval = 5000;

        this.setInterval = setInterval(() => {
            this._send();
        }, interval);
    }

    /**
     * Метод показывает прелоадер
     */
    _showPreloader() {
        Utils.show(this.preloader);
    }

    /**
     * Метод скрывает прелоадер
     */
    _hidePreloader() {
        if (this.preloader) {
            Utils.hide(this.preloader);
        }
    }

    /**
     * Метод устанавливает hash в url
     */
    _setUrl() {
        if (!this.openLoadPage) {
            return;
        }

        const hash = this.id;

        window.history.pushState(null, '/', hash);
    }

    /**
     * Метод удаляет hash из url
     */
    _clearUrl() {
        if (!this.openLoadPage) {
            return;
        }

        if (window.history.pushState) {
            window.history.pushState('', '/', window.location.pathname);
        } else {
            window.location.hash = '';
        }
    }

    /**
     * Метод проверяет наличие хэша в url, и открывает соотвествующий попап.
     */
    _parseUrl() {
        const hash = window.location.hash;
        const isPlanoplan = hash.split('-')[0] === '#planoplan';

        if (!this.openLoadPage && hash) {
            return;
        }

        if (!hash) {
            return;
        }

        this.target = this.body.querySelector(`[data-popup-id="${hash}"]`);
        this.id = hash;

        if (isPlanoplan) {
            this.planoplanUid = hash.split('-')[1];
        }

        this.openButtons.ids.forEach((item) => {
            if (item === this.id) {
                this._makeOpen();
                this._seoSignal(this.id);
            }
        });
    }

    /**
     * Инициализация планоплана
     * @private
     */
    _planoplanInit() {
        window.Planoplan.init({
            width          : '100%',
            height         : '100%',
            uid            : this.planoplanUid,
            el             : 'planoplan',
            primaryColor   : '#0B1739',
            secondaryColor : '#F4F7F7',
            textColor      : '#000000',
            backgroundColor: '#FFFFFF'
        });
    }

    /**
     * Собираем данные для попапа зума в Избранном
     * @return {object} - данные для попапа
     * @private
     */
    _collectZoomData() {
        return {
            plan : this.target.dataset.plan || null,
            area : this.target.dataset.area || null,
            title: this.target.dataset.title || null,
            price: this.target.dataset.price || null,
            link : this.target.dataset.link || null
        };
    }
}

export default Popup;
